<template>
  <main class="mt-5">
    <div class="card mt-3">
      <!-- <div class="d-flex justify-content-center">  
          <div class="alert alert-warning justify-content-center align-items-center" style="width: 100%;">  
              <span class="font-weight-bold text-danger">توجه:</span>  
              <span class="mr-1">مرجوعی از  تعداد فروش و فروش خالص کسر شده است.</span>  
          </div>  
      </div> -->
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش محصولات مرجوعی</h5>
        <div style="flex: 1"></div>
        <ExcelDownload class="mr-3" :url="excelUrl" />
      </div>
      <div class="row px-4 not-in-print">
        <div class="row col-12 mb-1">
          <DatePickerRange class="col-md-6" v-model="filterDate" />
        </div>
        <div class="row col-md-12">
          <div class="col-5">
            <b-form-group label="دسته بندی">
              <treeselect
                :options="realOptions"
                v-model="category_id"
                :searchable="true"
                :show-count="true"
                noChildrenText="فرزندی وجود ندارد"
                noOptionsText="موردی وجود ندارد"
                noResultsText="موردی یافت نشد"
                :default-expand-level="1"
                label="title"
              >
                <label
                  slot="option-label"
                  slot-scope="{
                    node,
                    shouldShowCount,
                    count,
                    labelClassName,
                    countClassName,
                  }"
                  :class="labelClassName"
                >
                  {{ node.label }}
                </label>
              </treeselect>
            </b-form-group>
          </div>
          <div class="col-5">
            <b-form-group label="صندوق دار">
              <multiselect
                placeholder="انتخاب صندوق دار"
                v-model="cashierSelected"
                open-direction="bottom"
                :options="cashiers"
                label="name"
                track-by="id"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                :disabled="disabled"
              >
                <template slot="noOptions"> موردی یافت نشد </template>
                <template slot="noResult"> موردی یافت نشد </template>
              </multiselect>
            </b-form-group>
          </div>
        </div>
        <ProductSearch
          class="row col-md-12"
          ref="productSearch"
          :selectable="true"
          :disabled="disabled"
          @selectProduct="selectProduct"
          :show-label="false"
          @selectVariety="selectVariety"
        />
        <b-button
          class="col-md-2"
          variant="primary"
          @click="doFilter"
          :disabled="disabled"
          >فیلترسازی</b-button
        >
      </div>
      <div id="print" class="p-4">
        <b-table
          id="main-table"
          v-if="reports"
          bordered
          striped
          :fields="fields"
          :items="reports"
          responsive="sm"
        >
          <template v-slot:cell(product_id)="data">
            <a
              :href="`/admin/products/edit/${data.item.product_id}`"
              class="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
              >{{ data.item.product_id }}</a
            >
          </template>
          <!-- <template v-slot:cell(total_sale)="data">
            {{ data.item.total_sale < 0 ? "-" : ""
            }}{{ data.item.total_sale | price }}
          </template> -->
          <template v-slot:cell(product_title)="data">
            <a
              target="_blank"
              v-if="data.item.product_title"
              :href="'/admin/products/edit/' + data.item.product_id"
              >{{ data.item.product_title }}</a
            >
            <span v-else>{{ data.item.variety_title }}</span>
          </template>
          <template v-slot:cell(mini_order_ids)="data">
            <span v-if="data.item.mini_order_ids && data.item.mini_order_ids.length">
              {{ data.item.mini_order_ids.join("، ") }}
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:cell(refund_count)="data">
            {{ data.item.refund_count | price }}
          </template>
          <!-- <template v-slot:cell(sales_count)="data">
            {{ data.item.sales_count | price }}
          </template> -->
          <template v-slot:cell(purchase_price)="data">
            {{ data.item.purchase_price | price }}
          </template>
          <template v-slot:cell(sell_price)="data">
            {{ data.item.sell_price | price }}
          </template>
          <template v-slot:cell(sum_refund_amount)="data">
            {{ data.item.sum_refund_amount | price }}
          </template>
          <!-- <template v-slot:cell(total)="data">
            {{ data.item.total | price }}
          </template> -->
          <!-- <template v-slot:cell(total_sell)="data">
            {{ data.item.total_sell | price }}
          </template> -->
          <template v-slot:cell(sum_discount_amount)="data">
            {{ data.item.sum_discount_amount | price }}
          </template>
          <template #bottom-row="data">
            <b-td colspan="3">
              <div class="text-center">جمع کل</div>
            </b-td>
            <b-td>
              {{ totals.purchase_price | price }}
            </b-td>
            <!-- <b-td>
              {{ totals.sell_price | price }}
            </b-td> -->
            <b-td>
              {{ totals.discount_amount | price }}
            </b-td>
            <b-td>
              {{ totals.refund_quantity | price }}
            </b-td>
            <b-td>
              {{ totals.refund_amount | price }}
            </b-td>
            <!-- <b-td>
              {{ totals.sales_count | price }}
            </b-td>
            <b-td>
              {{ totals.total | price }}
            </b-td>
            <b-td>
              {{ totals.total_sell | price }}
            </b-td> -->
            <b-td>
              {{ totals.main_quantity | price }}
            </b-td>
            <b-td>
              {{ totals.shop_store_quantity | price }}
            </b-td>
          </template>
        </b-table>

        <div v-if="categories && !reports" class="alert alert-primary">
          دیتایی وجود ندارد
        </div>
        <div v-else-if="categories && disabled" class="alert alert-primary">
          در حال بارگزاری
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { BTable, BFormGroup, BFormInput, BButton, BTd } from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import reportMixin from "@@/core/mixins/reportMixin";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

function Filter() {
  this.search = "";
}
Filter.prototype.set = function (filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};
export default {
  name: "storeBalanceReport",
  components: {
    BTable,
    BFormGroup,
    BFormInput,
    Treeselect,
    ExcelDownload,
    DatePickerRange,
    ProductSearch,
    BButton,
    BTd,
  },
  configProvider,
  data() {
    return {
      disabled: true,
      fields: [
        {
          key: "product_id",
          label: "شناسه محصول",
        },
        {
          key: "product_title",
          label: "عنوان",
        },
        {
          key: "mini_order_ids",
          label: "شناسه سفارش",
        },
        {
          key: "purchase_price",
          label: "قیمت خرید",
        },
        // {
        //   key: "sell_price",
        //   label: "قیمت فروش",
        // },
        {
          key: "sum_discount_amount",
          label: "تخفیف",
        },
        {
          key: "refund_count",
          label: "تعداد مرجوعی",
        },
        {
          key: "sum_refund_amount",
          label: "قیمت مرجوعی",
        },
        // {
        //   key: "sales_count",
        //   label: "تعداد فروش",
        // },
        // {
        //   key: "total",
        //   label: "فروش خالص",
        // },
        // {
        //   key: "total_sell",
        //   label: "فروش کل",
        // },
        {
          key: "main_quantity",
          label: "تعداد انبار مرکزی",
        },
        {
          key: "shop_store_quantity",
          label: "تعداد انبار فروشگاه",
        },
      ],
      page: 1,
      reports: null,
      sortBy: null,
      sortDesc: null,
      category_id: null,
      cashierSelected: null,
      categories: [],
      cashiers: [],
      totals: [],
      Product_id: "",
      Variety_id: "",
      filterDate: {
        endDate: "",
        startDate: "",
      },
      filter: new Filter(),
      appliedFilter: new Filter(),
      disabledRest: true,
    };
  },
  mixins: [reportMixin],

  created() {
    this.loadCategoriesData();
    this.loadCashiersData();
  },
  computed: {
    excelUrl() {
      const params = {
        category_id: this.category_id == 0 || !this.category_id ? "" : this.category_id,
        product_id: this.Product_id ? this.Product_id.id : "",
        variety_id: this.Variety_id ? this.Variety_id.id : "",
        from_date: this.filterDate.startDate,
        to_date: this.filterDate.endDate,
        cashier_id: this.cashierSelected ? this.cashierSelected.id : "",
      };

      const queryString = Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&");

      return `admin/reports/products-refund-new?${queryString}`;
    },
    realOptions() {
      let temp = this.$root.addLabel(this.categories);
      temp.unshift({
        label: "ندارد",
        children: [],
        id: 0,
      });

      return temp;
    },
    sum_refund_count() {
      if (this.reports) {
        return this.reports.reduce((total, item) => total + Number(item.refund_count), 0);
      } else {
        return 0;
      }
    },
    sum_sales_count() {
      if (this.reports) {
        return this.reports.reduce((total, item) => total + Number(item.sales_count), 0);
      } else {
        return 0;
      }
    },
    sum_discount_amount() {
      if (this.reports) {
        return this.reports.reduce(
          (total, item) => total + Number(item.sum_discount_amount),
          0
        );
      } else {
        return 0;
      }
    },
    sum_refund_amount() {
      if (this.reports) {
        return this.reports.reduce(
          (total, item) => total + Number(item.sum_refund_amount),
          0
        );
      } else {
        return 0;
      }
    },
    total() {
      if (this.reports) {
        return this.reports.reduce((total, item) => total + Number(item.total), 0);
      } else {
        return 0;
      }
    },
  },
  methods: {
    async loadCategoriesData() {
      try {
        const response = await this.$axios.get("admin/categories", {
          params: { all: 1 },
        });
        this.categories = response.data.data.categories;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    async loadCashiersData() {
      try {
        const response = await this.$axios.get("admin/get-admins");
        this.cashiers = response.data.data.admins;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    resetFilter() {
      this.Product_id = "";
      this.Variety_id = "";
      this.disabledRest = true;
      this.loadData();
    },
    doFilter() {
      this.loadData();
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    selectVariety(data) {
      this.Variety_id = data;
    },
    selectProduct(data) {
      this.Product_id = data;
    },
    async loadData() {
      this.appliedFilter.set(this.filter);
      this.disabledRest = false;
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/reports/products-refund-new", {
          params: {
            category_id:
              this.category_id == 0 || !this.category_id ? "" : this.category_id,
            product_id: this.Product_id ? this.Product_id.id : "",
            variety_id: this.Variety_id ? this.Variety_id.id : "",
            cashier_id: this.cashierSelected ? this.cashierSelected.id : "",
            from_date: this.filterDate.startDate,
            to_date: this.filterDate.endDate,
          },
        });
        this.reports = response.data.data.reports;
        this.totals = response.data.data.totals;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
    showVarieties(productId) {
      this.$root.$emit("bv::show::modal", "show-varieties-modal");
      this.showVarietiesProductId = productId;
    },
  },
};
</script>

<style>
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }

  .app-content .side-app {
    padding: 0 !important;
  }

  .print-only {
    display: block !important;
  }

  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
  }
  #print {
    width: 80%;
  }

  #main-table th:last-child,
  #main-table td:last-child {
    display: none;
  }

  #print .not-in-print {
    display: none;
  }

  .mr-2-print {
    margin-right: 20px;
  }
}
</style>
